import { css } from '@emotion/react';

export const iconBase = css({
  flexShrink: 0,
  height: 16,
  width: 16,
});
export const iconSmall = css({
  height: 12,
  width: 12,
});
export const iconLarge = css({
  height: 24,
  width: 24,
});
export const iconXLarge = css({
  height: 32,
  width: 32,
});
export const icon2xLarge = css({
  height: 48,
  width: 48,
});
export const icon3xLarge = css({
  height: 64,
  width: 64,
});
export const icon4xLarge = css({
  height: 88,
  width: 88,
});
export const iconScale = css({
  height: 'auto',
  width: '100%',
});
export const iconDark = css({
  // $color-dark-1;
  color: '#090a0b',
});
export const iconWhite = css({
  // $color-white;
  color: '#fff',
});
export const iconBlue = css({
  // $color-brand;
  color: '#007bb3',
});
export const iconLight2 = css({
  // $color-light-2;
  color: '#dee0e2',
});
export const svgLoadWrapper = css({
  height: 0,
  overflow: 'hidden',
});
